module.exports = __webpack_public_path__ + "assets/img/pigeon-attack.fa1b83c9.png";